// Pinterest.tsx
import React from "react";
import styles from "./Pinterest.module.css";

const PinterestIcon = () => {
  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    event.preventDefault();
    // Fallback to opening in the browser with a delay (if the app isn't installed)
    setTimeout(() => {
      const pinterestWebUrl =
        "https://www.pinterest.com/thehideawaycampingretreat/";
      window.open(pinterestWebUrl, "_blank");
    }, 25);
  };

  return (
    <img
      onClick={handleClick}
      src="/icons/pinterest_icon.png"
      alt="Pinterest"
      className={styles.icon}
    />
  );
};

export default PinterestIcon;
